import config from "@/config";
//系统路由
const routes = [
	{
		name: "layout",
		path: "/",
		component: () => import("@/layout"),
		redirect: config.DASHBOARD_URL || "/dashboard",
		children: [],
	},
	{
		path: "/login",
		component: () => import("@/views/login"),
		meta: {
			title: "登录",
		},
	},
	{
		path: "/track",
		component: () => import("@/views/other/track"),
		meta: {
			title: "物流跟踪",
		},
	},
	{
		path: "/fee_trail",
		component: () => import("@/views/fee/feeTrail"),
		meta: {
			title: "价格试算",
		},
	},
	{
		path: "/sellPrice",
		component: () => import("@/views/other/sellPrice"),
		meta: {
			title: "查询销售价",
		},
	},
	{
		path: "/sellPriceMob",
		component: () => import("@/views/other/sellPriceMob"),
		meta: {
			title: "运费计算-手机版",
		},
	},
	{
		path: "/trackMob",
		component: () => import("@/views/other/trackMob"),
		meta: {
			title: "批量追踪-手机版",
		},
	},
	{
		path: "/user_register",
		component: () => import("@/views/login/userRegister"),
		meta: {
			title: "注册",
		},
	},
	{
		path: "/reset_password",
		component: () => import("@/views/login/resetPassword"),
		meta: {
			title: "重置密码",
		},
	},
];

export default routes;
